import React from "react";

interface GTMScriptProps {
    helmetComponent: React.ComponentType;
    scriptSrc?: string;
}

export default ({ helmetComponent, scriptSrc = "https://www.googletagmanager.com/gtm.js" }: GTMScriptProps) => {
    const Helmet = helmetComponent;

    return (
        <Helmet>
            <script>
                {`(function() {
                    window.dataLayer = window.dataLayer || [];
                    dataLayer.push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });
                    const elements = document.getElementsByTagName('script')[0];
                    const script = document.createElement('script');
                    script.async = true;
                    script.onload = function () {return window.grebban.gtm.scriptCallback('GTM');}
                    script.src = '` +
                    scriptSrc +
                    `?id=' + window.grebban.gtm.trackingKey;
                    script.id = 'GTMScript';
                    elements.parentNode.insertBefore(script, elements);
                })()`}
            </script>
        </Helmet>
    );
};
